import React from "react";
import { Link } from "react-router-dom"; // if you're using React Router

function Footer() {
  return (
    <footer className="main-footer wow fadeInUp" data-wow-duration="2s">
      <div className="container">
        <div className="row">
          {/* Logo + Description */}
          <div className="col-lg-4 wow fadeInLeft" data-wow-delay="0.5s">
            <div className="footer-col logo-desc">
              <img src="/project/images/logo.png" alt="EV Parts NZ Logo" className="footer-logo" />
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.8s">
            <div className="footer-col">
              <h4>QUICK LINKS</h4>
              <ul>
                <li><i className="fa fa-caret-right"></i> <Link to="/about">About Us</Link></li>
                <li><i className="fa fa-caret-right"></i> <Link to="/used-car-parts">Used Car Parts</Link></li>
                <li><i className="fa fa-caret-right"></i> <Link to="/blogs">Blogs</Link></li>
                <li><i className="fa fa-caret-right"></i> <Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>
          </div>

          {/* Our Services */}
          <div className="col-lg-3 wow fadeInUp" data-wow-delay="1s">
            <div className="footer-col">
              <h4>OUR SERVICES</h4>
              <ul>
                <li><i className="fa fa-caret-right"></i> <Link to="/cash-for-cars">Cash For Cars</Link></li>
                <li><i className="fa fa-caret-right"></i> <Link to="/car-removal">Car Removal Services</Link></li>
                <li><i className="fa fa-caret-right"></i> <Link to="/car-wrecking">Car Wrecking</Link></li>
                <li><i className="fa fa-caret-right"></i> <Link to="/scrap-disposal">Scrap Disposal</Link></li>
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 wow fadeInRight" data-wow-delay="1.2s">
            <div className="footer-col">
              <h4>CONTACT US</h4>
              <ul className="contact-info">
                <li><i className="fa fa-phone"></i> 021747792</li>
                <li><i className="fa fa-envelope"></i> evpartsnz@gmail.com</li>
                <li><i className="fa fa-map-marker"></i> 8 Dent Place, Papakura, Auckland</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom mt-4 pt-3 d-flex justify-content-between align-items-center border-top wow fadeInUp" data-wow-delay="1.5s">
          <p className="mb-0">
            Copyright © 2025 <strong>Matebiz.com</strong>. All Rights Reserved.
          </p>
          <div className="social-icons mt-2">
            <a href="#"><i className="fa fa-facebook me-2"></i></a>
            <a href="#"><i className="fa fa-instagram me-2"></i></a>
            <a href="#"><i className="fa fa-times me-2"></i></a>
            <a href="#"><i className="fa fa-linkedin me-2"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
